import { SvrConn } from "../utils/axios";
/**
 * metodo para traer los modulos activos de usuario
 */
export const getModuloUsuario = async (AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/modulo/getmoduloxusr", {
      AreaId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * Trae todos los modulos 
*/
export const getModuloAll = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/modulo/getmoduloall");
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
*  Buscar Los Modulos por area sin importar el estado
*/
export const getModuloAllxArea = async (AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/modulo/getmoduloallarea",{AreaId});
  } catch (Error) {
    res = Error;
  }
  return res;
};

/**
*  Buscar Los Modulos por area y por Id
*/

export const getModuloInt = async (AreaId, ModuloId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/modulo/getmoduloint",{AreaId, ModuloId});
  } catch (Error) {
    res = Error;
  }
  return res;
};

/**
 * 
 */
export const setBloqueaModule = async (areaId, moduloId, TagId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/modulo/setbloqueamodulo", { areaId, moduloId,TagId });
  } catch (Error) {
    res = Error;
  }
  return res;
};

/**
 * 
 */
export const actualizaModulo = async(data)=>{
  let res = {};
    try {
      res = await SvrConn.post("/api/modulo/setactualizadmodulo", data);
    } catch (Error) {
      res = Error;
    }
    return res;

}
